import { faCloudArrowUp } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useRef } from 'react';

const defaultAccept = "xlsx,.xls,image/*,.doc,.docx,.ppt,.pptx,.txt,.pdf";

interface FileInputProps {
    accept?: string;
    selectedFile: File | null;
    onFileSelect: (file?: File) => void;
    hasError?: boolean;
}

const FileInput: React.FC<FileInputProps> = ({ 
    selectedFile, 
    onFileSelect,
    accept,
    hasError
}) => {
    const theme = useTheme();
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => { 
        if (event.target.files && event.target.files.length > 0) {
            onFileSelect(event.target.files[0]);
        }
        else {
            onFileSelect(undefined);
        }
    }, [onFileSelect]);

    useEffect(() => {
        if (hasError && fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }, [hasError])

    return ( 
        <>
            <label 
                htmlFor="file-upload" 
                style={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'center',
                    width: '100%', 
                    height: '100%', 
                    border: 1, 
                    borderStyle: 'dashed', 
                    borderColor: theme.palette.primary.main,
                    color: theme.palette.primary.main,
                    cursor: 'pointer'  
                }}
            >
                <FontAwesomeIcon icon={faCloudArrowUp} style={{ fontSize: '1.5rem', paddingTop: '10px', paddingBottom: '5px' }} />
                <Typography 
                    sx={{ paddingBottom: '5px' }}
                >
                    {selectedFile ? selectedFile.name : 'Browse file to upload'}
                </Typography>
            </label>
            <input
                id="file-upload"
                type="file"
                onChange={(event) => handleFileChange(event)}
                accept={accept ?? defaultAccept}
                style={{ display: 'none' }}
                ref={fileInputRef}
            />
        </>
            
    );
};

export default FileInput;
